import React, { useState, useRef, useEffect } from "react";
import "../../assets/css/custom.css";
import { FiSearch } from "react-icons/fi";

const CustomDropdown = ({
  dropdownData = [],
  dropdownValue,
  setDropdownValue,
  name,
  errors,
  fieldName,
  eventType,
  disabled,
  ShouldValidate = true,
  textboxError,
}) => {
  const [filteredDropdownData, setFilteredDropdownData] = useState(dropdownData);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [inputValue, setInputValue] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (eventType === "Update" && dropdownValue && !inputValue && dropdownData.length > 0) {
      const selectedOption = dropdownData.find((option) => {
        if (fieldName === "country" && option.country_name) {
          return Number(option.id) === Number(dropdownValue);
        } else if (fieldName === "state" && option.name) {
          return Number(option.id) === Number(dropdownValue); 
        } else if (fieldName === "ticket" && option.name) {
          return Number(option.id) === Number(dropdownValue); 
        }else if (fieldName === "event_type" && option.name) {
          return Number(option.id) === Number(dropdownValue); 
        }else if (fieldName === "zonal_type" && option.name) {
          return Number(option.id) === Number(dropdownValue); 
        }
        return false;
      });
      if (selectedOption) {
        setInputValue(
          selectedOption.name ||
          selectedOption.country_name ||
          selectedOption.value ||
          selectedOption.year ||
          selectedOption
        );
      }
    }
  }, [dropdownData, dropdownValue, eventType, fieldName, inputValue]);

  useEffect(() => {
    if (searchQuery) {
      const filteredData = dropdownData.filter((option) => {
        if (fieldName === "country" && option.country_name) {
          return option.country_name.toLowerCase().includes(searchQuery.toLowerCase());
        } else if (fieldName === "state" && option.name) {
          return option.name.toLowerCase().includes(searchQuery.toLowerCase());
        }else if (fieldName === "event_type" && option.name) {
          return option.name.toLowerCase().includes(searchQuery.toLowerCase());
        } else if (fieldName === "zonal_type" && option.name) {
          return option.name.toLowerCase().includes(searchQuery.toLowerCase());
        }
        return false;
      });
      setFilteredDropdownData(filteredData);
    } else {
      setFilteredDropdownData(dropdownData);
    }
  }, [searchQuery, dropdownData, fieldName]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleDropdownSelect = (option) => {
    let selectedValue = "";
    if (fieldName === "country") {
      selectedValue = option.country_name;
      setDropdownValue(option.id ? Number(option.id) : "");
    } else if (fieldName === "state") {
      selectedValue = option.name;
      setDropdownValue(option.id ? Number(option.id) : "");
    } else if (fieldName === "event_type") {
      selectedValue = option.name;
      setDropdownValue(option.id ? Number(option.id) : "");
    } else if (fieldName === "zonal_type") {
      selectedValue = option.name;
      setDropdownValue(option.id ? Number(option.id) : "");
    }

    setInputValue(selectedValue);
    setSearchQuery("");
    setDropdownVisible(false);
  };

  const handleClearSearch = () => {
    setInputValue("");
    setDropdownValue(""); 
    setSearchQuery("");
    setDropdownVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
        setSearchQuery("");
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Debugging log
  console.log(`CustomDropdown (${fieldName}) props:`, {
    dropdownData,
    dropdownValue,
    inputValue,
  });

  return (
    <div className="multiselect_div single_inputdrop" ref={dropdownRef}>
      <div className="input-container" style={{ position: "relative" }}>
        <input
          type="text"
          value={inputValue}
          disabled={disabled}
          onClick={() => !disabled && setDropdownVisible(!isDropdownVisible)}
          className="form-control"
          placeholder={`Select ${name}`}
          style={{ paddingRight: "30px", cursor: "pointer" }}
        />
        {inputValue && !disabled && (
          <button
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              zIndex: 1,
              display: "flex",
              alignItems: "center",
            }}
            onClick={handleClearSearch}
          >
            ✕
          </button>
        )}
      </div>

      {isDropdownVisible && !disabled && (
        <div className="dropdown-search-container">
          <ul className="dropdown-list">
            <li>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  placeholder={`Search ${name}`}
                  className="dropdown-search-input"
                  style={{ paddingLeft: "30px" }}
                />
                <FiSearch
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#ccc",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </li>
            {filteredDropdownData.map((option) => (
              <li key={option.id || option} onClick={() => handleDropdownSelect(option)}>
                {fieldName === "country"
                  ? option.country_name
                  : fieldName === "state"
                  ? option.name
                  : fieldName === "event_type"
                  ? option.name
                  : fieldName === "zonal_type"
                  ? option.name
                  : null}
              </li>
            ))}
          </ul>
        </div>
      )}
      {ShouldValidate && errors && errors[fieldName] && (
        <p className="text-danger pos_abos">{errors[fieldName]}</p>
      )}
    </div>
  );
};

export default CustomDropdown;